import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';
import { ITrackingObject, TrackingObjectNamesEnum } from '../../tracking.data';

export const TRACKING_CLIENT_SCHEMA = Object.freeze({
  ID: '',
  LOCAL_ID: '',
});
const RECORD = generateSchema(TRACKING_CLIENT_SCHEMA);
const KEYS: any = generateKeys(TRACKING_CLIENT_SCHEMA);

export class ClientTrackingObject
  extends Record(RECORD)
  implements ITrackingObject {
  static KEYS = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get name() {
    return TrackingObjectNamesEnum.client;
  }

  get properties() {
    return this.toJS();
  }
}
